import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismTable,
  PrismTableHeadersThSublabel,
} from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdFrequency from 'lumen/components/hotel/strategy/tables/cells/td-frequency';
import HotelStrategyTablesCellsTdNonComputable from 'lumen/components/hotel/strategy/tables/cells/td-non-computable';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import HotelStrategyTablesCellsThStrategyDetail from 'lumen/components/hotel/strategy/tables/cells/th-strategy-detail';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
  SUBTYPE_VALUES_KEY_STRATEGY,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailLosSignature {
  Args: {
    initialSorts: unknown;
    onTableSort: unknown;
    sortFunction: unknown;
    subtypes: unknown;
  };
}

export default class HotelStrategyTablesTableDetailLos extends Component<HotelStrategyTablesTableDetailLosSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO_HEADER,
        subcolumns: [
          {
            ...COLUMN_CONFIG.HOTELINFO,
            name: this.intl.t('general.hotels'),
            tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
            valuePath: valuePathHotel,
          },
        ],
      },
    ];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.subtypes.forEach((subtype) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRate = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathDiscount = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathFrequencyWeekday = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.FREQUENCY_WEEKDAY}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathFrequencyWeekend = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.FREQUENCY_WEEKEND}`;

      columns.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        name: subtype.label,
        thComponent: HotelStrategyTablesCellsThStrategyDetail,
        width: 4 * COLUMN_WIDTH.DEFAULT,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: subtype.label,
        textAlign: 'center',
        hasRightBorder: true,
        hasCompareButton: true,
        subtypeHeaderAttributes: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileBookingSubtype: subtype.isMobileBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileExpediaSubtype: subtype.isMobileExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMealtypeType: subtype.isMealtypeType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosBookingSubtype: subtype.isPosBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosExpediaSubtype: subtype.isPosExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          isBranddotcomMemberRatesSubType:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            subtype.isBranddotcomMemberRatesSubType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMemberRatesType: subtype.isMemberRatesType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          label: subtype.label,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          formattedLabel: subtype.formattedLabel[SUBTYPE_VALUES_KEY_STRATEGY],
        },
        subcolumns: [
          {
            name: this.intl.t('rates.rate'),
            valuePath: valuePathRate,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: subtype.label,
          },
          {
            name: this.intl.t('strategy.metric_block.discount'),
            valuePath: valuePathDiscount,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdNonComputable,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
          },
          {
            name: this.intl.t('settings.reports.frequency'),
            subLabel: this.intl.t('reports.frequency_weekdays_short'),
            valuePath: valuePathFrequencyWeekday,
            thComponent: PrismTableHeadersThSublabel,
            thClassNames: 'truncate text-200--bold',
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdFrequency,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
          },
          {
            name: this.intl.t('settings.reports.frequency'),
            subLabel: this.intl.t('reports.frequency_weekends_short'),
            valuePath: valuePathFrequencyWeekend,
            thComponent: PrismTableHeadersThSublabel,
            thClassNames: 'truncate text-200--bold',
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdFrequency,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            hasRightBorder: true,
          },
        ],
      });
    });

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const losData = [...this.args.losDataPerHotelInfo.values()];

    losData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
      };

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.subtypes.forEach((subtype) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.RATE];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.DISCOUNT];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        row[
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.FREQUENCY_WEEKDAY}`
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ] = rowData[subtype.id][COLUMN_PROPERTIES.FREQUENCY_WEEKDAY];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        row[
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.FREQUENCY_WEEKEND}`
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ] = rowData[subtype.id][COLUMN_PROPERTIES.FREQUENCY_WEEKEND];
      });

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@initialSorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container-slack"
    />
  </template>
}
